import { V2Button } from '@abyss/web/ui/Button';
import { Link } from '@abyss/web/ui/Link';
import { Markdown } from '@abyss/web/ui/Markdown';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { StyledFontSizeModal } from './FontSizeModal.style';

export const FontSizeModal: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const linkRef = useRef<HTMLAnchorElement>(null);

  const handleClose = () => {
    setIsOpen(false);

    // Focus back on the link after closing the modal
    setTimeout(() => {
      linkRef.current?.focus();
    }, 0);
  };
  const { t } = useTranslation();

  const footer = (
    <V2Button data-testid="font-size-modal-close-button" onClick={handleClose}>
      {t('FONT_SIZE_CONTENT.CloseButton')}
    </V2Button>
  );

  return (
    <>
      <Link
        css={{
          fontSize: '$sm',
          color: '#196ECF',
          textDecoration: 'none',
          cursor: 'pointer',
        }}
        data-testid="font-size-link"
        onClick={() => {
          setIsOpen(true);
        }}
        ref={linkRef}
      >
        {t('FONT_SIZE')}
      </Link>
      {isOpen && (
        <StyledFontSizeModal
          closeOnClickOutside={false}
          data-testid="font-size-modal"
          footer={footer}
          header={t('FONT_SIZE_CONTENT.Title')}
          isOpen={isOpen}
          onClose={handleClose}
          size="$sm"
        >
          <Markdown>{t('FONT_SIZE_CONTENT.Content')}</Markdown>
        </StyledFontSizeModal>
      )}
    </>
  );
};

export default FontSizeModal;
